// Standalone announcement rotation; independent of header component setup.
class AnnouncementBar extends HTMLElement {
  current = 0;
  interval;
  connectedCallback() {
    this.slides = [...this.querySelectorAll('.announcement-bar__slide')];
    for (const [ref, delta] of [['previous', -1], ['next', 1]]) {
      const button = this.querySelector(`[ref="${ref}"]`);
      if (!button) continue;
      button.removeAttribute('on:click');
      button.onclick = () => this.show(this.current + delta);
    }
    this.show(this.current);
    clearInterval(this.interval);
    const seconds = Number(this.getAttribute('autoplay'));
    if (seconds > 0 && this.slides.length > 1) {
      this.interval = setInterval(() => {
        if (!document.hidden && !this.matches(':hover')) this.show(this.current + 1);
      }, seconds * 1000);
    }
  }
  disconnectedCallback() { clearInterval(this.interval); }
  show(index) {
    if (!this.slides.length) return;
    this.current = (index + this.slides.length) % this.slides.length;
    this.slides.forEach((slide, i) => slide.setAttribute('aria-hidden', String(i !== this.current)));
  }
}
if (!customElements.get('announcement-bar-component')) customElements.define('announcement-bar-component', AnnouncementBar);
